import SurgossegiIcon from "@/components/Shared/Icons/SurgossegiIcon";
import FogszabalyzasIcon from "@/components/Shared/Icons/FogszabalyzasIcon";
import FogpotlasIcon from "@/components/Shared/Icons/FogpotlasIcon";
import InybetegsegIcon from "@/components/Shared/Icons/InybetegsegIcon";
import MegelozesIcon from "@/components/Shared/Icons/MegelozesIcon";
import { 
  Target, 
  Sparkles, 
  MessageSquare, 
  Shield, 
  Stethoscope, 
  Baby, 
  Activity 
} from "lucide-react";
import { ReactNode } from "react";

export interface ServiceData {
  id: number;
  title: string;
  description: string;
  icon: ReactNode;
  href: string;
  color: string;
  bgColor: string;
  hoverColor: string;
  hoverBorder: string;
  category?: string;
}

export const allServices: ServiceData[] = [
  {id: 13, title: "Állkapocsízületi gyógytorna", description: "TMJ gyógytorna és TMI-CMD manuálterápia Major Vanesszával Győrújbaráton.", icon: <Activity className="h-6 w-6" />, href: "/allkapocsizuleti-gyogytorna-gyor", color: "text-hill-primary", bgColor: "bg-hill-primary/10", hoverColor: "group-hover:text-hill-primary", hoverBorder: "group-hover:border-hill-primary", category: "Kezelés"},
  {
    id: 1,
    title: "Sürgősségi ellátás",
    description: "Azonnali segítségnyújtás és fájdalomcsillapítás váratlan fogászati panaszok esetén.",
    icon: <SurgossegiIcon size={24} />,
    href: "/surgossegi-ellatas",
    color: "text-red-500",
    bgColor: "bg-red-50",
    hoverColor: "group-hover:text-red-500",
    hoverBorder: "group-hover:border-red-500",
    category: "Sürgősségi"
  },
  {
    id: 2,
    title: "Implantológia",
    description: "A legmodernebb implantációs eljárások az elveszített fogak élethű és tartós pótlására.",
    icon: <Target className="h-6 w-6" />,
    href: "/implantologia",
    color: "text-blue-500",
    bgColor: "bg-blue-50",
    hoverColor: "group-hover:text-blue-500",
    hoverBorder: "group-hover:border-blue-500",
    category: "Sebészet"
  },
  {
    id: 3,
    title: "Esztétikus fogászat",
    description: "Vegyük vissza mosolya fényét prémium héjakkal, fehérítéssel és esztétikus tömésekkel.",
    icon: <Sparkles className="h-6 w-6" />,
    href: "/esztetikus-fogaszat",
    color: "text-amber-500",
    bgColor: "bg-amber-50",
    hoverColor: "group-hover:text-amber-500",
    hoverBorder: "group-hover:border-amber-500",
    category: "Esztétika"
  },
  {
    id: 4,
    title: "Fogszabályozás",
    description: "Személyre szabott megoldások gyermekeknek és felnőtteknek a tökéletesen szabályos fogsorért.",
    icon: <FogszabalyzasIcon size={24} />,
    href: "/fogszabalyozas",
    color: "text-indigo-500",
    bgColor: "bg-indigo-50",
    hoverColor: "group-hover:text-indigo-500",
    hoverBorder: "group-hover:border-indigo-500",
    category: "Kezelés"
  },
  {
    id: 5,
    title: "Fogpótlás",
    description: "Cirkónium koronák, hidak és kivehető pótlások a funkció és az esztétika teljes helyreállításáért.",
    icon: <FogpotlasIcon size={24} />,
    href: "/fogpotlas",
    color: "text-emerald-500",
    bgColor: "bg-emerald-50",
    hoverColor: "group-hover:text-emerald-500",
    hoverBorder: "group-hover:border-emerald-500",
    category: "Kezelés"
  },
  {
    id: 6,
    title: "Logopédiai foglalkozás",
    description: "Szakértő segítség beszédhibák, nyelvlökéses nyelés és egyéb logopédiai kihívások esetén.",
    icon: <MessageSquare className="h-6 w-6" />,
    href: "/nyelvlokeses-nyeles-logopedia-gyor",
    color: "text-purple-500",
    bgColor: "bg-purple-50",
    hoverColor: "group-hover:text-purple-500",
    hoverBorder: "group-hover:border-purple-500",
    category: "Logopédia"
  },
  {
    id: 7,
    title: "Szájhigiénia",
    description: "Professzionális tisztítás és tanácsadás a fogak és az íny egészségének megőrzése érdekében.",
    icon: <Shield className="h-6 w-6" />,
    href: "/szajhigenia",
    color: "text-cyan-500",
    bgColor: "bg-cyan-50",
    hoverColor: "group-hover:text-cyan-500",
    hoverBorder: "group-hover:border-cyan-500",
    category: "Prevenció"
  },
  {
    id: 8,
    title: "Szájsebészet",
    description: "Fájdalommentes műtéti beavatkozások, bölcsességfog-eltávolítás és csontpótlás.",
    icon: <Stethoscope className="h-6 w-6" />,
    href: "/szajsebeszet",
    color: "text-rose-500",
    bgColor: "bg-rose-50",
    hoverColor: "group-hover:text-rose-500",
    hoverBorder: "group-hover:border-rose-500",
    category: "Sebészet"
  },
  {
    id: 9,
    title: "Gyermekfogászat",
    description: "Kedves és türelmes ellátás a legkisebbeknek, hogy a fogdokihoz járás élmény maradjon.",
    icon: <Baby className="h-6 w-6" />,
    href: "/gyermekfogaszat",
    color: "text-orange-500",
    bgColor: "bg-orange-50",
    hoverColor: "group-hover:text-orange-500",
    hoverBorder: "group-hover:border-orange-500",
    category: "Kezelés"
  },
  {
    id: 10,
    title: "Digitális fogászat",
    description: "Precíziós diagnosztika és tervezés a legmodernebb 3D technológiák segítségével.",
    icon: <Activity className="h-6 w-6" />,
    href: "/digitalis-technologiak",
    color: "text-slate-500",
    bgColor: "bg-slate-50",
    hoverColor: "group-hover:text-slate-500",
    hoverBorder: "group-hover:border-slate-500",
    category: "Technológia"
  },
  {
    id: 11,
    title: "Ínybetegségek",
    description: "A parodontitis hatékony kezelése és az íny egészségének hosszú távú megőrzése.",
    icon: <InybetegsegIcon size={24} />,
    href: "/inybetegsegek",
    color: "text-lime-600",
    bgColor: "bg-lime-50",
    hoverColor: "group-hover:text-lime-600",
    hoverBorder: "group-hover:border-lime-600",
    category: "Prevenció"
  },
  {
    id: 12,
    title: "Megelőzés",
    description: "Rendszeres kontroll és prevenciós kezelések a komolyabb beavatkozások elkerüléséért.",
    icon: <MegelozesIcon size={24} />,
    href: "/megelozes",
    color: "text-teal-500",
    bgColor: "bg-teal-50",
    hoverColor: "group-hover:text-teal-500",
    hoverBorder: "group-hover:border-teal-500",
    category: "Prevenció"
  },
];
